module.exports = __webpack_public_path__ + "static/media/cornerMatBrown95.5f4c2a45.png";